import { Button } from '@calizahq/react-components-v2'
import React from 'react'

import { useAlertContext } from '@/context'
import { HomeQualityCheckMutations } from '@/graphql/mutations/homeQualityChecks.mutations'
import { useMobile } from '@/hooks'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import { HomeQualityCheckStatus } from '@/types/HomeQualityCheck'

type Props = {
  homeQualityCheckId: number
  onClearHomeQualityCheckId: () => void
  toggle: () => void
}

export const HomeReadiness = ({ onClearHomeQualityCheckId, toggle, homeQualityCheckId }: Props) => {
  const { isTablet } = useMobile()
  const { setAlert } = useAlertContext()
  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(
    HomeQualityCheckMutations.updateHomeQualityCheck(),
    {
      onSuccess: () => {
        toggle()
        setAlert('Home is ready!', 'success')
        // Defer navigation until after the sheet close animation completes (~300ms)
        setTimeout(onClearHomeQualityCheckId, 300)
      },
      onError: () => {
        setAlert('Failed to mark home as ready. Please try again.', 'error')
      },
    },
  )

  const handleHomeReadiness = () => {
    mutate({
      homeQualityCheck: {
        homeQualityCheckId,
        status: HomeQualityCheckStatus.READY,
      },
    })
  }

  return (
    <div className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
      <h5 className="mb-4 text-header-sm leading-120 md:text-header-md">What is the status of the Home?</h5>
      <ul>
        <li className="mb-2 text-p-xs">Have you inspected the entire Home?</li>
        <li className="mb-2 text-p-xs">Have you rated the previous cleaning Host?</li>
        <li className="mb-2 text-p-xs">Have you audited the Access Instructions?</li>
      </ul>
      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size={isTablet ? 'medium' : 'small'}
          variant="secondary"
        >
          Not Ready
        </Button>
        <Button
          className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
          disabled={isMutationLoading}
          isLoading={isMutationLoading}
          onClick={handleHomeReadiness}
          size={isTablet ? 'medium' : 'small'}
        >
          Ready
        </Button>
      </div>
    </div>
  )
}
